import { apiClient } from '@src/services/http-common'
import { useMutation } from '@tanstack/react-query'
import { useFetchPerson } from '../api/person-api';
import { Person } from './@types/GetPersonDTO'
import { EditProfileDTO } from './@types/EditProfileDTO'


export const useGetProfile = (): [Person | null, boolean] => {
  const [personData, isLoading] = useFetchPerson(); 

  return [personData, isLoading];
};

const submitProfile = async (formData: EditProfileDTO) => {
  const response = await apiClient.put('/Profile', formData)
  return response.data as EditProfileDTO
}

export const useSubmitProfile = () => {
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: submitProfile,
  })

  return [mutateAsync, isPending, reset] as const
}
